import moment from "moment";

import { LifeEventDto } from "enrollment/queries/useLifeEventQuery/types";

export const isValidLifeEventDate = (lifeEvent?: LifeEventDto, dateStr?: string) => {
  let isValid = false;
  if (lifeEvent && dateStr) {
    const date = moment(dateStr).startOf('day');
    const lifeEventMax = getMaxDateFromToday(lifeEvent.max_days_before_event);
    const lifeEventMin = getMinDateFromToday(lifeEvent.max_days_after_event);
    isValid = date.isSameOrAfter(lifeEventMin) && date.isSameOrBefore(lifeEventMax);
  }
  return isValid;
};

export const getMaxDateFromToday = (daysBefore: number): Date => {
  return moment().add(daysBefore, 'days').startOf('day').toDate();
};

export const getMinDateFromToday = (daysAfter: number): Date => {
  return moment().subtract(daysAfter, 'days').startOf('day').toDate();
};
